<template>
<div>
  <b-button 
    variant="outline-dark" 
    class="btn-block text-left"
    :class="{'radio-box-active': pickup_type == courierKeys.JNTP}"
    @click="$emit( 'update:pickup_type' , courierKeys.JNTP )">
     <b-form-radio 
      v-model="pickup_type" 
      name="some-radios" 
      :value="courierKeys.JNTP">
      {{text.JNTP.title}}<h6 class="text-muted">{{text.JNTP.description}}</h6>
    </b-form-radio>
  </b-button>
  <b-button 
    variant="outline-dark" 
    class="btn-block text-left"
    :class="{'radio-box-active': pickup_type == courierKeys.JNTD}"
    @click="$emit( 'update:pickup_type' , courierKeys.JNTD )">
     <b-form-radio 
      v-model="pickup_type" 
      name="some-radios" 
      :value="courierKeys.JNTD">
      {{text.JNTD.title}}<h6 class="text-muted">{{text.JNTD.description}}</h6>
    </b-form-radio>
  </b-button>
  <!-- <b-button 
    variant="outline-dark" 
    class="btn-block text-left"
    v-if="isVisible"
    :class="{'radio-box-active': selected == courierKeys.JNTPF}"
    @click="selectType(courierKeys.JNTPF)">
      <b-form-radio 
        v-model="selected" 
        name="some-radios" 
        :value="courierKeys.JNTPF">
        {{text.JNTPF.title}}<h6 class="text-muted">{{text.JNTPF.description}}</h6>
      </b-form-radio>
  </b-button> -->
</div>
</template>
<script>
export default {
    props: {
        data:Object,
        pickup_type: String
    },
  data() {
    return {
      courierKeys:{
        JNTD:'JNTD',
        JNTP:'JNTP',
        JNTPF:'JNTPF'
      },
      text:{
        JNTD:{
          title:'ดรอปเอง',
          description:'ร้านสาขานำพัสดุไปส่งที่จุดรับพัสดุ J&T Express เอง'
        },
        JNTP:{
          title:'ขนส่งเข้ารับ',
          description:'บริการขนส่งเข้ารับพัสดุถึงหน้าร้านสาขา โปรดสร้างพัสดุอย่างน้อย 1 ชิ้นก่อนเวลาตัดรอบ'
        },
        JNTPF:{
          title:'ขนส่งเข้ารับฟรี ขั้นต่ำ 10 ชิ้น',
          description:'ส่งพัสดุขั้นต่ำ 10 ชิ้นต่อหนึ่งใบเสร็จ ขนส่งเข้ามารับที่หน้าร้านฟรี'
        }
      },
      isClicked:true,
    }
  },
  mounted(){
  },
  methods: {
  },
  computed:{
    isVisible(){
      let allow = this.data.courier.JNT.JNTP.find(( id ) => {
        return this.data.shop_id  == id
      })
      if( allow ){
        return true
      }else{
        return false
      }

    }
  }
};
</script>
<style scoped>
.btn-outline-dark:hover {
    color: #000;
    background-color: #ffffff00;
    border-color: #0a84ff;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
    color: #000;
    background-color: #0000000d;
    border-color: #0a84ff;
}
.btn-outline-dark {
    border-color: #cad1d7;
}
.radio-box-active{
  border-color: #0a84ff;
}
</style>